export const Customersendpoint = {
  getCustomerDetails: `/admin/report/customer-list?vendorId`,
};
